import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import './Dashboard.css'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import {
  CssBaseline,
  Drawer,
  Box,
  AppBar,
  Toolbar,
  List,
  Typography,
  Divider,
  Button,
  IconButton,
  Container,
  Grid,
  Link,
  Menu,
  MenuItem,
} from '@material-ui/core'
import MenuIcon from '@material-ui/icons/Menu'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import {
  mainListItems,
  mainListItemsIfChemist,
  mainListItemsIfWholesaler,
  mainListItemsIfPlanAdmin,
  mainListItemsIfPlanSubAdmin,
} from './ListItem'
import { auth } from '../../Backend/firebase/firebase'
import { useDispatch } from 'react-redux'
import { logoutSave } from '../../DataStore/Slices/userSlice'
import CheckUserProvider from '../../AllHooks/CheckUserProvider'

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://kaipsoolretail.web.app/" target="_blank">
        Kaipsool Pharmatech
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  )
}

const drawerWidth = 240

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'initial',
    width: '100%'
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'initial',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 240,
  },
}))

function Dashboard(props) {
  const classes = useStyles()
  const [open, setOpen] = useState(true)
  const [profileMenuOption, setProfileMenuOption] = useState(null)
  const history = useHistory()
  const dispatch = useDispatch()
  const location = useLocation();
  const { userData } = CheckUserProvider()
  const details = navigator.userAgent;
  const regexp = /android|iphone|kindle|ipad/i;

  useEffect(async () => {
    if (userData) {
      console.log('Event Triggered');
    }
  }, [userData])

  useEffect(() => {
    if(regexp.test(details)) {
      setOpen(false)
    }
  }, [location]);

  const profileMenuOpen = (event) => {
    setProfileMenuOption(event.currentTarget)
  }

  const profileMenuClose = () => {
    setProfileMenuOption(null)
  }

  const handleDrawerOpen = () => {
    setOpen(true)
  }
  const handleDrawerClose = () => {
    setOpen(false)
  }

  const logout = async () => {
    auth.signOut()
    dispatch(logoutSave())
    profileMenuClose()
    localStorage.setItem(process.env.REACT_APP_EMPLOYER_ISLOGIN, false);
    history.push('/')
    window.location.reload(true);
  }

  const routeToProfile = () => {
    setProfileMenuOption(null)
    history.push('/activity/profile')
  }

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="absolute"
        className={clsx(classes.appBar, open && classes.appBarShift)}
      >
        <Toolbar className={classes.toolbar}>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            className={clsx(
              classes.menuButton,
              open && classes.menuButtonHidden,
            )}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            component="h1"
            variant="h6"
            color="inherit"
            noWrap
            className={classes.title}
          >
            {props.productView}
          </Typography>
          <IconButton color="inherit" onClick={profileMenuOpen}>
            <AccountCircleIcon />
          </IconButton>
          <Menu
            id="simple-menu"
            anchorEl={profileMenuOption}
            keepMounted
            open={Boolean(profileMenuOption)}
            onClose={profileMenuClose}
          >
            <MenuItem onClick={routeToProfile} className="profileMenuIcon">
              Profile
            </MenuItem>
            <MenuItem
              className="profileMenuIcon"
              onClick={logout}
            >
              Logout
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="persistent"
        classes={{
          paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
        }}
        className="mobileDrawer"
        open={open}
      >
        <div className="dashboard__employerLogoContainer">
          <img
            src={"/assets/Logo.webp"}
            alt="Employer_Logo"
            className="dashboard__employerLogo"
          />
          <div className={classes.toolbarIcon}>
            <IconButton onClick={handleDrawerClose}>
              <ChevronLeftIcon />
            </IconButton>
          </div>
        </div>
        <Divider />
        {userData && userData != null && <>
          {(userData?.uid == "cOn2A0wayefGD5WpRQKV0TbpRXH3" || userData?.uid == "upMp5iVxlcSuXO4fGdUVn1n2R5A3") ? (
            <List>{mainListItemsIfPlanAdmin}</List>
          ) : (userData?.uid == "3rm0e3zW6tUi9iPf0SjGZc12Otn2" || userData?.uid == "08skTH56PkPIF2zuhJDPB8EB5Mg1") ? (
            <List>{mainListItemsIfPlanSubAdmin}</List>
          ) : (userData?.userRole == "Chemist") ? (
            <List>{mainListItemsIfChemist}</List>
          ) : (userData?.userRole == "Wholesaler") ? (
            <List>{mainListItemsIfWholesaler}</List>
          ) : (
            <List>{mainListItems}</List>
          )}
        </>}
        <Divider />
      </Drawer>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
            {(location.pathname == "/chemist/create-order" || location.pathname == "/supply/create-order") ? <div /> : <div className="backButton">
              <div className="inline__block">
                  <Button 
                      onClick={history.goBack}
                      color="error"
                      variant='outlined'
                      className="registerEmp__btnRemove">
                      <ArrowBackIcon />&nbsp; {'Go Back'}
                  </Button>
              </div>
            </div>}
            <Grid item xs={12} md={12} lg={12}>
              {props.children}
            </Grid>
          </Grid>
          <Box pt={4}>
            <Copyright />
          </Box>
        </Container>
      </main>
    </div>
  )
}

export default Dashboard
